var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"no-click-animation":"","persistent":"","max-width":"800","scrollable":"","hide-overlay":"","fullscreen":_vm.$vuetify.breakpoint.xsOnly}},[_c('plan-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }